import React from 'react';

import Image from 'next/image';
import HeadingBody from './heading-body';

const TrustpilotCarousel: React.FC<{
  title?: string;
  intro?: string;
  sectionId?: string;
}> = ({ title, intro, sectionId }) => {
  return (
    <section id={sectionId} className="grid lg:grid-cols-2 my-12 md:my-16">
      <Image
        src="/trustpilot-reviews-img.png"
        alt="Trustpilot Carousel"
        width={960}
        height={640}
      />
      <div className="flex flex-col justify-start gap-6 lg:gap-10 p-10 bg-[#F2F5F8]">
        <div className="text-center">
          {title?.length > 0 && (
            <HeadingBody
              className="font-semibold"
              level="2"
              tagName="h2"
              title={title}
            />
          )}
          {intro?.length > 0 ? <p>{intro}</p> : null}
        </div>
        <div
          className="trustpilot-widget min-h-[140px]"
          data-locale="en-US"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="63caa6848fcd1c82bbeac42d"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
          data-review-languages="en"
        >
          <a
            href="https://www.trustpilot.com/review/leafwell.com"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrustpilotCarousel;
